import PhoneUtil from '@/shared/util/phoneutil';

import validator from 'validator';

export default function isPhoneOrEmail(values, value) {
  return PhoneUtil.isValidNumber(value) || validator.isEmail(value || '');
}
